import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";

import { IValidationConfig } from "./types";
import {
  getValidationScreenConfig,
  checkCode,
} from "../../api/services/psaContactValidation";
import { IError } from "../../types/common";

export const ThunkGetValidationConfig = createAsyncThunk<
  IValidationConfig,
  { crmId: string },
  IError
>(
  "psaContactValidation/getValidationConfig",
  async ({ crmId }, { rejectWithValue }) => {
    try {
      const { data } = await getValidationScreenConfig(crmId);
      return data;
    } catch (err) {
      const error = err as AxiosError<{ message: string }>;
      return rejectWithValue(
        error.response?.data || { message: error.message }
      );
    }
  }
);

export const ThunkCheckCode = createAsyncThunk<
  any,
  { crmId: string; code: string },
  IError
>(
  "psaContactValidation/checkCode",
  async ({ crmId, code }, { rejectWithValue }) => {
    try {
      const { data } = await checkCode({ crmId, code });
      return data;
    } catch (err) {
      const error = err as AxiosError<{ message: string }>;
      return rejectWithValue(
        error.response?.data || { message: error.message }
      );
    }
  }
);
